"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMask = void 0;
const codec_1 = require("../../codec");
const tx_1 = require("../../codec/cosmos/tx/v1beta1/tx");
const constant_1 = require("../../constant");
const eth_1 = require("../../eth");
const index_1 = require("../../index");
const util_1 = require("../../util");
const address_1 = require("../../util/address");
const blockchain_1 = require("../../util/blockchain");
const eip712_1 = require("../../util/eip712");
const ethermint_1 = require("../../util/ethermint");
const evm_1 = require("../../util/evm");
const generic_1 = require("../../util/generic");
const legacyEIP712_1 = require("../../util/legacyEIP712");
const network_1 = require("../../util/network");
const provider_1 = require("../../util/provider");
const wallet_1 = require("../../wallet");
const build_1 = require("@cosmjs/amino/build");
const proto_signing_1 = require("@cosmjs/proto-signing");
const tx_2 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const ethSignUtils = __importStar(require("eth-sig-util"));
const ethers_1 = require("ethers");
const constant_2 = require("../../constant");
const eip6963Provider_1 = require("../eip6963Provider");
const error_1 = require("./error");
const legacy_accounts_1 = require("./legacy-accounts");
const CONTRACT_HASH = {
    Ethereum: {
        // use same rinkeby contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "0x086e1b5f67c0f7ca8eb202d35553e27e964899e2",
        [constant_1.Network.DevNet]: "0x086e1b5f67c0f7ca8eb202d35553e27e964899e2",
        [constant_1.Network.LocalHost]: "0x086e1b5f67c0f7ca8eb202d35553e27e964899e2",
        [constant_1.Network.MainNet]: "0xf4552877A40c1527D38970F170993660084D4541",
    },
    ['Binance Smart Chain']: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085",
        [constant_1.Network.DevNet]: "0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085",
        [constant_1.Network.LocalHost]: "0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085",
        [constant_1.Network.MainNet]: "0x3786d94AC6B15FE2eaC72c3CA78cB82578Fc66f4",
    },
    Arbitrum: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "0x43138036d1283413035b8eca403559737e8f7980",
    },
    Polygon: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "0x61B9503Fe023E1F1Dd0ab7417923cB0A41DD9E0c",
    },
    OKC: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "0x7e8D8c98a016877Cb3103e837Fc71D41b155aF70",
    },
    Mantle: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
    Optimism: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
    Avalanche: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
    Base: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
    Monad: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
    Carbon: {
        //Carbon does not support Metamask legacy mnemonic sign in
        [constant_1.Network.TestNet]: "",
        [constant_1.Network.DevNet]: "",
        [constant_1.Network.LocalHost]: "",
        [constant_1.Network.MainNet]: "",
    },
};
const REGISTRY_CONTRACT_ABI = eth_1.ABIs.keyStorage;
const ENCRYPTION_VERSION = "x25519-xsalsa20-poly1305";
const MNEMONIC_MATCH_REGEX = /-----BEGIN MNEMONIC PHRASE-----([a-z\s]*)-----END MNEMONIC PHRASE-----/im;
const MNEMONIC_MATCH_REGEX_LEGACY = /^[a-z\s]*$/i;
const getEncryptMessage = (input) => {
    return `
  !!! Attention !!! Please make sure you are connecting to https://app.dem.exchange, do not confirm decrypt if you're connecting to untrusted sites.
  -----BEGIN MNEMONIC PHRASE-----
  ${input}
  -----END MNEMONIC PHRASE-----
  `
        .trim()
        .replace(/^\s+/gm, "");
};
/**
 * TODO: Add docs
 */
class MetaMask extends eip6963Provider_1.Eip6963Provider {
    constructor(network, legacyEip712SignMode = false) {
        super();
        this.network = network;
        this.legacyEip712SignMode = legacyEip712SignMode;
        this.blockchain = 'Ethereum';
        this.connectedAccount = '';
    }
    static createMetamaskSigner(metamask, evmChainId, pubKeyBase64, addressOptions) {
        const evmHexAddress = util_1.AddressUtils.ETHAddress.publicKeyToAddress(Buffer.from(pubKeyBase64, "base64"), addressOptions);
        const signDirect = (_, doc) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const txBody = tx_2.TxBody.decode(doc.bodyBytes);
            const authInfo = tx_1.AuthInfo.decode(doc.authInfoBytes);
            const msgs = txBody.messages.map(message => {
                const msg = codec_1.registry.decode(Object.assign({}, message));
                return {
                    typeUrl: message.typeUrl,
                    value: msg,
                };
            });
            const fee = {
                amount: (_b = (_a = authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : [],
                gas: (_d = (_c = authInfo.fee) === null || _c === void 0 ? void 0 : _c.gasLimit.toString()) !== null && _d !== void 0 ? _d : "0",
            };
            const aminoMsgs = msgs.map(msg => index_1.AminoTypesMap.toAmino(msg));
            const { sig, signedDoc } = yield metamask.signEip712(evmHexAddress, doc.accountNumber.toString(), evmChainId, aminoMsgs, fee, txBody.memo, authInfo.signerInfos[0].sequence.toString());
            const signedTxBody = {
                messages: msgs,
                memo: signedDoc.memo,
            };
            const signedTxBodyEncodeObject = {
                typeUrl: "/cosmos.tx.v1beta1.TxBody",
                value: signedTxBody,
            };
            const signedTxBodyBytes = codec_1.registry.encode(signedTxBodyEncodeObject);
            const signDoc = proto_signing_1.makeSignDoc(signedTxBodyBytes, doc.authInfoBytes, signedDoc.chain_id, parseInt(signedDoc.account_number));
            const sigBz = Uint8Array.from(Buffer.from(sig, 'hex'));
            return {
                signed: signDoc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    // Remove recovery `v` from signature
                    signature: Buffer.from(sigBz.slice(0, -1)).toString('base64'),
                },
            };
        });
        const signAmino = (_, doc) => __awaiter(this, void 0, void 0, function* () {
            const { account_number, msgs, fee, memo, sequence } = doc;
            const { sig, signedDoc } = yield metamask.signEip712(evmHexAddress, account_number, evmChainId, msgs, fee, memo, sequence);
            const sigBz = Uint8Array.from(Buffer.from(sig, 'hex'));
            return {
                signed: signedDoc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    // Remove recovery `v` from signature
                    signature: Buffer.from(sigBz.slice(0, -1)).toString('base64'),
                },
            };
        });
        const getAccounts = () => __awaiter(this, void 0, void 0, function* () {
            const address = yield metamask.defaultAccount();
            return [
                {
                    algo: "secp256k1",
                    address,
                    pubkey: Uint8Array.from(Buffer.from(pubKeyBase64, 'base64')),
                },
            ];
        });
        const signLegacyEip712 = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            const { account_number, chain_id, msgs, fee, memo, sequence } = doc;
            // Only MsgMergeAccount will have an Eth address signer, other generic transaction will be cosmos address signer
            // FeePayer here is only used for legacy EIP-712
            const feePayer = index_1.AminoTypesMap.fromAmino(msgs[0]).typeUrl === codec_1.TxTypes.MsgMergeAccount ? util_1.AddressUtils.ETHAddress.publicKeyToBech32Address(Buffer.from(pubKeyBase64, "base64"), addressOptions) : signerAddress;
            const { sig, signedDoc } = yield metamask.signEip712(evmHexAddress, account_number, chain_id, msgs, fee, memo, sequence, feePayer);
            return {
                signed: signedDoc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    signature: Buffer.from(sig, 'hex').toString('base64'),
                },
                feePayer,
            };
        });
        const sendEvmTransaction = (api, req) => __awaiter(this, void 0, void 0, function* () {
            try {
                const request = yield ethermint_1.populateEvmTransactionDetails(api, req);
                const response = yield metamask.sendEvmTransaction(request);
                return response;
            }
            catch (error) {
                console.error(error);
                throw (error_1.parseEvmError(error, index_1.ProviderAgent.MetamaskExtension));
            }
        });
        const signMessage = (address, message) => __awaiter(this, void 0, void 0, function* () {
            return metamask.personalSign(address, message);
        });
        return {
            type: wallet_1.CarbonSignerTypes.BrowserInjected,
            legacyEip712SignMode: metamask.legacyEip712SignMode,
            signDirect,
            signAmino,
            getAccounts,
            signLegacyEip712,
            sendEvmTransaction,
            signMessage,
        };
    }
    static signAndRecoverPubKey(provider, enableJwtAuth) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield provider.defaultAccount();
            const message = enableJwtAuth ? index_1.AuthUtils.getAuthMessage() : evm_1.DEFAULT_PUBLIC_KEY_MESSAGE;
            const signature = yield provider.personalSign(address, message);
            const publicKeyHex = index_1.EvmUtils.recoverPublicKey(message, signature);
            return {
                publicKey: Buffer.from(publicKeyHex, 'hex').toString('base64'),
                signature,
                message,
            };
        });
    }
    static getNetworkParams(network, blockchain = 'Ethereum') {
        if (blockchain === 'Carbon') {
            return MetaMask.getCarbonEvmNetworkParams(network);
        }
        const isMainnet = network === constant_1.Network.MainNet;
        if (blockchain === 'Monad' && !isMainnet) {
            return constant_1.MONAD_TESTNET;
        }
        switch (blockchain) {
            case 'Binance Smart Chain':
                return isMainnet ? constant_2.BSC_MAINNET : constant_2.BSC_TESTNET;
            case 'Arbitrum':
                return isMainnet ? constant_2.ARBITRUM_MAINNET : constant_2.ARBITRUM_TESTNET;
            case 'Polygon':
                return isMainnet ? constant_2.POLYGON_MAINNET : constant_2.POLYGON_TESTNET;
            case 'OKC':
                return isMainnet ? constant_2.OKC_MAINNET : constant_2.OKC_TESTNET;
            case 'Mantle':
                return isMainnet ? constant_1.MANTLE_MAINNET : constant_1.MANTLE_TESTNET;
            case 'Optimism':
                return isMainnet ? constant_1.OP_MAINNET : constant_1.OP_TESTNET;
            case 'Avalanche':
                return isMainnet ? constant_1.AVALANCHE_MAINNET : constant_1.AVALANCHE_TESTNET;
            case 'Base':
                return isMainnet ? constant_1.BASE_MAINNET : constant_1.BASE_TESTNET;
            default:
                // metamask should come with Ethereum configs
                return isMainnet ? constant_2.ETH_MAINNET : constant_2.ETH_TESTNET;
        }
    }
    static getCarbonEvmNetworkParams(network) {
        switch (network) {
            case constant_1.Network.LocalHost:
                return constant_2.CARBON_EVM_LOCALHOST;
            case constant_1.Network.DevNet:
                return constant_2.CARBON_EVM_DEVNET;
            case constant_1.Network.TestNet:
                return constant_2.CARBON_EVM_TESTNET;
            default:
                return constant_2.CARBON_EVM_MAINNET;
        }
    }
    static getRequiredChainId(network, blockchain = 'Ethereum') {
        if (blockchain === "Carbon") {
            return Number(ethermint_1.parseChainId(constant_1.CarbonEvmChainIDs[network]));
        }
        const isMainnet = network === constant_1.Network.MainNet;
        if (blockchain === 'Monad' && !isMainnet) {
            return 10143;
        }
        switch (blockchain) {
            case 'Binance Smart Chain':
                return isMainnet ? 56 : 97;
            case 'Mantle':
                return isMainnet ? 5000 : 5003;
            case 'Arbitrum':
                return isMainnet ? 42161 : 421611;
            case 'Polygon':
                return isMainnet ? 137 : 80001;
            case 'OKC':
                return isMainnet ? 66 : 65;
            case 'Optimism':
                return isMainnet ? 10 : 11155420;
            case 'Avalanche':
                return isMainnet ? 43114 : 43113;
            case 'Base':
                return isMainnet ? 8453 : 84532;
            default:
                // Fallback to Ethereum chain ID
                return isMainnet ? 1 : 5;
        }
    }
    checkProvider(blockchain = this.blockchain) {
        const config = constant_1.NetworkConfigs[this.network];
        if (!config[blockchain_1.BLOCKCHAIN_V2_TO_V1_MAPPING[blockchain]]) {
            throw new Error(`MetaMask login not supported for this network ${this.network}`);
        }
        const ethNetworkConfig = config[blockchain_1.BLOCKCHAIN_V2_TO_V1_MAPPING[blockchain]];
        const provider = new ethers_1.ethers.providers.JsonRpcProvider(ethNetworkConfig.rpcURL);
        return provider;
    }
    getBlockchain() {
        return this.blockchain;
    }
    syncConnectedAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.connectedAccount = yield this.defaultAccount();
            return this.connectedAccount;
        });
    }
    syncBlockchain() {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const chainIdHex = (yield (metamaskAPI === null || metamaskAPI === void 0 ? void 0 : metamaskAPI.request({ method: "eth_chainId" })));
            const chainId = chainIdHex ? parseInt(chainIdHex, 16) : undefined;
            const blockchain = blockchain_1.getBlockchainFromChainV2(chainId);
            this.blockchain = blockchain;
            return { chainId, blockchain };
        });
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            const ethereum = yield this.getConnectedAPI();
            return new ethers_1.ethers.providers.Web3Provider(ethereum).getSigner();
        });
    }
    getDefaultMetamaskProvider() {
        const metamaskProvider = super.getProvider(index_1.SupportedEip6963Provider.MetaMask);
        return metamaskProvider === null || metamaskProvider === void 0 ? void 0 : metamaskProvider.provider;
    }
    getConnectedAPI() {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskProvider = this.getDefaultMetamaskProvider();
            if (!metamaskProvider) {
                throw new Error("MetaMask not connected, please check that your extension is enabled");
            }
            return metamaskProvider;
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getConnectedAPI();
        });
    }
    defaultAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const accounts = (yield metamaskAPI.request({ method: "eth_requestAccounts" }));
            const [defaultAccount] = accounts;
            if (!defaultAccount) {
                throw new Error("No default account on MetaMask, please create one first");
            }
            return defaultAccount;
        });
    }
    getEncryptedLegacyAccounts(network = constant_1.Network.MainNet) {
        return __awaiter(this, void 0, void 0, function* () {
            const defaultAccount = yield this.defaultAccount();
            const legacyAccounts = network === constant_1.Network.MainNet ? legacy_accounts_1.LEGACY_ACCOUNTS_MAINNET : legacy_accounts_1.LEGACY_ACCOUNTS_TESTNET;
            const legacyAccBlockchains = [];
            for (const [blockchain] of Object.entries(legacyAccounts)) {
                for (const address of legacyAccounts[blockchain]) {
                    if (address.toLowerCase() === defaultAccount.toLowerCase()) {
                        legacyAccBlockchains.push(blockchain);
                        break;
                    }
                }
            }
            if (legacyAccBlockchains.length > 0) {
                const legacyMnemonicCiphers = legacyAccBlockchains.map((blockchain) => __awaiter(this, void 0, void 0, function* () { return (this.getMnemonicInfo(blockchain)); }));
                const results = yield Promise.all(legacyMnemonicCiphers);
                return results.filter((result) => result !== undefined);
            }
            return undefined;
        });
    }
    changeNetworkIfRequired(blockchain, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const required = yield this.isChangeNetworkRequired(blockchain, network);
            if (!required)
                return;
            const metamaskApi = yield this.getConnectedAPI();
            const requiredChainId = `0x${MetaMask.getRequiredChainId(network, blockchain).toString(16)}`;
            try {
                yield metamaskApi.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: requiredChainId }] });
                yield this.syncBlockchain();
            }
            catch (err) {
                // This error code indicates that the chain has not been added to MetaMask.
                try {
                    yield metamaskApi.request({
                        method: 'wallet_addEthereumChain',
                        params: [MetaMask.getNetworkParams(network, blockchain)],
                    });
                    yield this.syncBlockchain();
                }
                catch (err) {
                    throw new Error(`Please switch to ${blockchain} network on Metamask.`);
                }
            }
        });
    }
    isChangeNetworkRequired(blockchain, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskNetwork = yield this.syncBlockchain();
            const requiredChainId = MetaMask.getRequiredChainId(network, blockchain);
            return metamaskNetwork.chainId !== requiredChainId;
        });
    }
    verifyNetworkAndConnectedAccount(evmHexAddress, evmChainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.verifyNetwork(evmChainId);
            yield this.verifyConnectedAccount(evmHexAddress);
        });
    }
    verifyNetwork(evmChainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const network = network_1.carbonNetworkFromChainId(evmChainId);
            yield this.changeNetworkIfRequired("Carbon", network);
        });
    }
    verifyConnectedAccount(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const accounts = (yield metamaskAPI.request({ method: "eth_requestAccounts" }));
            if (!accounts.find(acc => acc.toLowerCase() === (address === null || address === void 0 ? void 0 : address.toLowerCase())))
                throw new Error(`${address} not connected on Metamask`);
        });
    }
    getMnemonicInfo(connectedBlockchain) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const defaultAccount = yield this.defaultAccount();
            let result;
            if (connectedBlockchain && connectedBlockchain !== 'Carbon' && CONTRACT_HASH[connectedBlockchain][this.network]) {
                const mnemonicCipher = yield this.getStoredMnemonicCipher(defaultAccount, connectedBlockchain).catch(err => {
                    console.error(err);
                    throw new Error(`Unable to retrieve stored mnemonic cipher from ${connectedBlockchain}`);
                });
                if (mnemonicCipher) {
                    const mnemonic = (_a = yield this.decryptCipher(mnemonicCipher)) !== null && _a !== void 0 ? _a : '';
                    const privateKey = `0x${address_1.SWTHAddress.mnemonicToPrivateKey(mnemonic).toString('hex').toLowerCase()}`;
                    const bech32Address = address_1.SWTHAddress.privateKeyToAddress(address_1.SWTHAddress.mnemonicToPrivateKey(mnemonic), { network: this.network });
                    const evmHexAddress = address_1.ETHAddress.privateKeyToAddress(address_1.SWTHAddress.mnemonicToPrivateKey(mnemonic));
                    result = {
                        mnemonic,
                        chain: connectedBlockchain,
                        privateKey,
                        bech32Address,
                        evmHexAddress,
                    };
                }
            }
            return result;
        });
    }
    getStoredMnemonicCipher(account, blockchain) {
        return __awaiter(this, void 0, void 0, function* () {
            const contractHash = this.getContractHash(blockchain);
            const provider = this.checkProvider(blockchain);
            const contract = new ethers_1.ethers.Contract(contractHash, REGISTRY_CONTRACT_ABI, provider);
            const cipherTextHex = yield contract.map(account);
            if (!(cipherTextHex === null || cipherTextHex === void 0 ? void 0 : cipherTextHex.length) || cipherTextHex === "0x") {
                // value would be '0x' if not initialized
                return undefined;
            }
            return cipherTextHex;
        });
    }
    encryptMnemonic(mnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            const defaultAccount = yield this.defaultAccount();
            const publicKey = yield this.getEncryptionPublicKey(defaultAccount);
            const messageToEncrypt = getEncryptMessage(mnemonic);
            const cipher = ethSignUtils.encrypt(publicKey, {
                data: messageToEncrypt,
            }, ENCRYPTION_VERSION);
            const { version, nonce, ephemPublicKey, ciphertext } = cipher;
            const encryptedMnemonic = ethers_1.ethers.utils.toUtf8Bytes([version, nonce, ephemPublicKey, ciphertext].join("."));
            return Buffer.from(encryptedMnemonic).toString("hex");
        });
    }
    // create signed public key for merging of cosmos and ethereum accounts (Metamask V2)
    signPublicKeyMergeAccount(publicKey, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = `${ethermint_1.PUBLIC_KEY_SIGNING_TEXT}${publicKey}`;
            return (yield this.personalSign(address, message)).split("0x")[1];
        });
    }
    personalSign(address, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const api = yield this.getConnectedAPI();
            const ethAddress = ethers_1.ethers.utils.getAddress(address);
            return (yield api.request({
                method: "personal_sign",
                params: [generic_1.appendHexPrefix(Buffer.from(message, "utf-8").toString("hex")), ethAddress],
            }));
        });
    }
    getEncryptionPublicKey(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const api = yield this.getConnectedAPI();
            const publicKey = (yield api.request({
                method: "eth_getEncryptionPublicKey",
                params: [address],
            }));
            return publicKey;
        });
    }
    signEip712(evmHexAddress, accountNumber, evmChainId, msgs, fee, memo, sequence, feePayer = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskNetwork = yield this.syncBlockchain();
            const metamaskChainId = metamaskNetwork.chainId ? `carbon_${metamaskNetwork.chainId.toString()}-1` : '';
            const metamaskAPI = yield this.getConnectedAPI();
            if (metamaskChainId !== evmChainId) {
                memo += "|CROSSCHAIN-SIGNING|signed-chain-id:" + metamaskChainId + ";" + "carbon-chain-id:" + evmChainId;
            }
            const stdSignDoc = build_1.makeSignDoc(msgs, fee, evmChainId, memo, accountNumber, sequence);
            const eip712Tx = this.legacyEip712SignMode ? legacyEIP712_1.legacyConstructEIP712Tx(Object.assign(Object.assign({}, stdSignDoc), { fee: Object.assign(Object.assign({}, fee), { feePayer }) })) : eip712_1.constructEIP712Tx(stdSignDoc, metamaskChainId);
            const sig = yield provider_1.signTransactionWrapper(() => __awaiter(this, void 0, void 0, function* () {
                const signature = (yield metamaskAPI.request({
                    method: 'eth_signTypedData_v4',
                    params: [
                        evmHexAddress,
                        JSON.stringify(eip712Tx),
                    ],
                }));
                return signature.split('0x')[1];
            }));
            return { sig, signedDoc: stdSignDoc };
        });
    }
    sendEvmTransaction(req) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.verifyNetworkAndConnectedAccount(req.from, req.chainId.toString());
            const api = yield this.getConnectedAPI();
            const tx = {
                from: req.from,
                to: req.to,
                value: req.value,
                gasPrice: req.gasPrice,
                gas: req.gasLimit,
                data: req.data,
                // type can only be 0 or 1 or 2
                type: `0x${req.type}`,
                chainId: req.chainId,
            };
            const txHash = (yield api.request({
                method: "eth_sendTransaction",
                params: [tx],
            }));
            return txHash;
        });
    }
    storeMnemonic(encryptedMnemonic, blockchain) {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            const storedMnemonicCipher = yield this.getStoredMnemonicCipher(defaultAccount, blockchain);
            if (storedMnemonicCipher) {
                throw new Error("Cannot store key on registry - key already exists for ETH account");
            }
            const contractHash = this.getContractHash(blockchain);
            const provider = this.checkProvider(blockchain);
            const contract = new ethers_1.ethers.Contract(contractHash, REGISTRY_CONTRACT_ABI, provider);
            const dataBytes = Buffer.from(encryptedMnemonic, "hex");
            const unsignedTx = yield contract.populateTransaction.Store(dataBytes);
            const txHash = (yield metamaskAPI.request({
                method: "eth_sendTransaction",
                params: [
                    Object.assign(Object.assign({}, unsignedTx), { from: defaultAccount }),
                ],
            }));
            return txHash;
        });
    }
    login(blockchain) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (blockchain === 'Carbon') {
                throw new Error('Carbon EVM does not support Metamask Legacy');
            }
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            const cipherTextHex = yield this.getStoredMnemonicCipher(defaultAccount, blockchain);
            const chainIdHex = (yield metamaskAPI.request({ method: "eth_chainId" }));
            const chainId = parseInt(chainIdHex, 16);
            const requiredChainId = this.getRequiredChain(this.network, chainId);
            if (chainId !== requiredChainId) {
                const requiredNetworkName = (_a = blockchain_1.ChainNames[requiredChainId]) !== null && _a !== void 0 ? _a : blockchain_1.ChainNames[3];
                throw new Error(`MetaMask not connected to correct network, please use ${requiredNetworkName} (Chain ID: ${requiredChainId})`);
            }
            const mnemonic = this.decryptCipher(cipherTextHex);
            return mnemonic;
        });
    }
    decryptCipher(cipherTextHex) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            if (!cipherTextHex || !cipherTextHex.length) {
                return null;
            }
            const cipherText = ethers_1.ethers.utils.toUtf8String(cipherTextHex);
            const [version, nonce, ephemPublicKey, ciphertext] = cipherText.split(".");
            const cipher = {
                version,
                nonce,
                ephemPublicKey,
                ciphertext,
            };
            const decryptedCipherText = (_a = (yield metamaskAPI.request({
                method: "eth_decrypt",
                params: [Buffer.from(JSON.stringify(cipher)).toString('hex'), defaultAccount],
            }))) === null || _a === void 0 ? void 0 : _a.trim();
            // legacy encrypted mnemonic doesnt include warning message.
            if (decryptedCipherText.match(MNEMONIC_MATCH_REGEX_LEGACY)) {
                return decryptedCipherText;
            }
            // match line with prefix 'mnemonic: '
            const match = decryptedCipherText.match(MNEMONIC_MATCH_REGEX);
            // invalid cipher
            if (!match) {
                console.error("invalid account info retrieved from contract");
                console.error(decryptedCipherText);
                throw new Error("Retrieved invalid account on blockchain, please check console for more information.");
            }
            return (_b = match[1]) === null || _b === void 0 ? void 0 : _b.trim();
        });
    }
    getRequiredChain(network, currentChainId) {
        const isMainnet = network === constant_1.Network.MainNet;
        if (!isMainnet && currentChainId === 10143) {
            this.blockchain = 'Monad';
            return 10143;
        }
        switch (currentChainId) {
            case 1: // Ethereum Mainnet
            case 5: // Ethereum Goerli Testnet
                this.blockchain = 'Ethereum';
                return isMainnet ? 1 : 5;
            case 56: // Binance Smart Chain Mainnet
            case 97: // Binance Smart Chain Testnet
                this.blockchain = 'Binance Smart Chain';
                return isMainnet ? 56 : 97;
            case 42161: // Arbitrum Mainnet
            case 421611: // Arbitrum Testnet
                this.blockchain = 'Arbitrum';
                return isMainnet ? 42161 : 421611;
            case 137: // Polygon Mainnet
            case 80001: // Polygon Testnet
                this.blockchain = 'Polygon';
                return isMainnet ? 137 : 80001;
            case 66: // OKC Mainnet
            case 65: // OKC Testnet
                this.blockchain = 'OKC';
                return isMainnet ? 66 : 65;
            case 5000: // Mantle Mainnet
            case 5003: // Mantle Testnet
                this.blockchain = 'Mantle';
                return isMainnet ? 5000 : 5003;
            case 10: // OP Mainnet
            case 11155420: // OP Sepolia Testnet
                this.blockchain = 'Optimism';
                return isMainnet ? 10 : 11155420;
            case 43114: // Avalanche Mainnet
            case 43113: // Avalanche Fuji Testnet
                this.blockchain = 'Avalanche';
                return isMainnet ? 43114 : 43113;
            case 8453:
            case 84532:
                this.blockchain = 'Base';
                return isMainnet ? 8453 : 84532;
            default:
                // Default fallback for Ethereum if no specific match found
                return isMainnet ? 1 : 5;
        }
    }
    getContractHash(blockchain = this.blockchain) {
        const contractHash = CONTRACT_HASH[blockchain][this.network];
        if (!contractHash) {
            throw new Error(`MetaMask login is not supported on ${this.network} on ${blockchain}`);
        }
        return contractHash;
    }
}
exports.MetaMask = MetaMask;
